import { useEffect } from 'react';
import { pageTitle } from '@/lib/page-title';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { ToolCatalogGrid } from '@/components/tools/ToolCatalogGrid';
import { ApprovalRail } from '@/components/trust/ApprovalRail';
import { SystemChecks } from '@/components/trust/SystemChecks';
import { SupportLine } from '@/components/trust/SupportLine';
import { trackPageView } from '@/lib/analytics';

// /tools: EVERY tool on one page, by what it is for (owner 2026-10-16: the
// pay-per-file tools sit with the others in their category, not in a folder
// of their own). Same frame and trust layer as the studios.
export default function QuickToolsHub() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    trackPageView('quicktools_hub');
  }, []);
  useEffect(() => {
    const previous = document.title;
    document.title = pageTitle(`${t('toolCats.metaTitle')} | FaceShot-ChopShop`);
    return () => {
      document.title = previous;
    };
  }, [t, i18n.language]);

  return (
    <div className="min-h-screen overflow-x-clip bg-background">
      <Navbar />
      <main className="pt-20 sm:pt-24">
        <div className="container mx-auto max-w-6xl px-4 md:px-8 xl:px-4">
          <header className="max-w-3xl">
            <p className="eyebrow">{t('toolCats.eyebrow')}</p>
            <h1 className="mt-3 text-balance font-display text-[32px] font-bold leading-[1.06] tracking-[-0.02em] sm:text-[46px]">
              {t('toolCats.h1a')} <span className="gradient-text">{t('toolCats.h1b')}</span>
            </h1>
            <p className="mt-3 text-pretty text-[15px] leading-relaxed text-muted-foreground sm:text-[1.05rem]">{t('toolCats.lead')}</p>
          </header>
          <ToolCatalogGrid className="mt-10" />
          <div className="mt-14 space-y-12 pb-16">
            <ApprovalRail kind="quick" />
            <SystemChecks checks={['quickNoCharge', 'quickNoAccount', 'quickDeleted', 'cardsToStripe']} />
            <SupportLine where="quicktools_hub" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
